import { useConfig } from '@gik/api/config/config';
import StreamClient from '@gik/core/utils/StreamClient';
import { useEffect } from 'react';
export interface IStreamConfig {
  streamUserToken: string;
  streamApiKey: string;
  streamAppId: string;
}

export function useStream(): IStreamConfig {
  const { data: config } = useConfig();

  const { streamAppId, streamApiKey, streamUserToken } = config || {
    streamAppId: null,
    streamApiKey: null,
    streamUserToken: null,
  };
  useEffect(() => {
    if (streamAppId && streamApiKey && streamUserToken) {
      StreamClient.init(streamApiKey, streamUserToken, streamAppId);
    }
  }, [streamAppId, streamApiKey, streamUserToken]);

  return null;
}
